<template>
  <CustomPage title="发票信息">
    <div slot="content" class="content">
      <div class="tips" v-if="checkState === 2">
        *资质审核中，您无法编辑审核中增票资质
      </div>
      <div class="tips red" v-if="checkState === null">
        *通过增票资质审核后您将可以开具增值税专用发票
      </div>
      <div class="tips red" v-if="checkState === 0">
        您的增票资质未通过审核，请修改后重新提交<br />原因：{{ rejectReason }}
      </div>
      <Form ref="form" :readonly="!edit" validate-trigger="onSubmit">
        <Field
          v-model="form.companyName"
          label="单位全称"
          placeholder="请输入单位全称"
          :rules="[{ required: true, message: '' }]"
          input-align="right"
        />
        <Field
          v-model="form.taxpayerNumber"
          label="单位税号"
          placeholder="请输入单位税号"
          :rules="[
            {
              validator: vaildSocialCreditCode,
              message: '请填写正确的统一社会信用代码',
            },
          ]"
          error-message-align="right"
          input-align="right"
        />
        <Field
          v-model="form.companyPhone"
          label="注册电话"
          placeholder="请输入注册电话"
          :rules="[{ required: true, message: '' }]"
          input-align="right"
        />
        <Field
          v-model="form.companyAddress"
          label="注册地址"
          placeholder="请输入注册地址"
          :rules="[{ required: true, message: '' }]"
          input-align="right"
        />
        <Field
          v-model="form.bankNo"
          label="银行账号"
          placeholder="请输入银行账号"
          :rules="[{ validator: bankCard, message: '请填写正确的银行卡账号' }]"
          error-message-align="right"
          input-align="right"
        />
        <Field
          v-model="form.bankName"
          label="开户银行"
          placeholder="请输入开户银行"
          :rules="[{ required: true, message: '' }]"
          input-align="right"
        />
        <div class="label">营业执照复印件</div>
        <Field
          class="field-uploader"
          :rules="[{ required: true, message: ' 请选择图片' }]"
        >
          <template #input>
            <Uploader
              :after-read="afterReadBusinessLicenceImg"
              v-model="form.businessLicenceImg"
              :max-count="1"
              right-icon="arrow"
              :deletable="edit"
            >
            </Uploader>
            <div class="tip">
              仅支持jpg、jpeg、png、gif文件，仅限上传1张，大小不超过5M
            </div>
          </template>
        </Field>
        <div class="label">一般纳税人认证资格复印件</div>
        <Field
          class="field-uploader"
          :rules="[{ required: true, message: ' 请选择图片' }]"
        >
          <template #input>
            <Uploader
              :after-read="afterReadTaxpayerIdentificationImg"
              v-model="form.taxpayerIdentificationImg"
              :max-count="1"
              right-icon="arrow"
              :deletable="edit"
            >
            </Uploader>
            <div class="tip">
              仅支持jpg、jpeg、png、gif文件，仅限上传1张，大小不超过5M
            </div>
          </template>
        </Field>
      </Form>
      <div class="bottom">
        <div class="btn" @click="onSubmit" v-if="edit">保存</div>
        <div
          class="btn"
          :class="{ disable: checkState === 2 }"
          @click="onEdit"
          v-else
        >
          编辑
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import Compressor from 'compressorjs'
import CustomPage from '@/components/custom-page.vue'
import { getInvoice, updateInvoice, addInvoice } from '@/api/setting/invoice'
import { uploadImage } from '@/api/index'
import { Form, Field, Uploader, Notify } from 'vant'
import { vaildSocialCreditCode, bankCard } from '@/utils/vaildate'
export default {
  components: { CustomPage, Form, Field, Uploader },
  data() {
    return {
      vaildSocialCreditCode,
      bankCard,
      edit: false,
      checkState: null,
      file: {
        businessLicenceImg: null,
        taxpayerIdentificationImg: null,
      },
      rejectReason: null,
      form: {
        id: null,
        companyName: null,
        taxpayerNumber: null,
        companyPhone: null,
        companyAddress: null,
        bankNo: null,
        bankName: null,
        businessLicenceImg: [],
        taxpayerIdentificationImg: [],
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getInvoice(this.$store.state.user.customerId).then((res) => {
        if (res.data) {
          this.checkState = res.data.checkState
          this.rejectReason = res.data.rejectReason
          for (const key in this.form) {
            if (Object.hasOwnProperty.call(this.form, key)) {
              if (
                key === 'businessLicenceImg' ||
                key === 'taxpayerIdentificationImg'
              ) {
                this.form[key] = res.data[key] ? [{ url: res.data[key] }] : []
                continue
              }
              this.form[key] = res.data[key]
            }
          }
        }
      }).catch(() => {
        
      })
    },
    onEdit() {
      if (this.checkState === 2) {
        return
      }
      this.edit = true
    },
    onSubmit() {
      this.$refs.form
        .validate()
        .then((res) => {
          this.submitForm()
        })
        .catch((err) => {
          Notify('信息填写有误')
        })
    },
    async submitForm() {
      this.$store.dispatch('app/showLoading')
      const params = this._.cloneDeep(this.form)
      const keyList = ['businessLicenceImg', 'taxpayerIdentificationImg']
      try {
        for (let i = 0; i < keyList.length; i++) {
          const key = keyList[i]
          params[key] = this.file[key]
            ? await this.uploadAvatar(this.file[key])
            : params[key][0]['url']
        }
      } catch (error) {
        this.$store.dispatch('app/hideLoading')
      }
      if (params.id) {
        updateInvoice(params)
          .then((res) => {
            Notify({ type: 'success', message: '保存成功' })
            this.$store.dispatch('app/hideLoading')
            this.clearFile()
            this.getData()
            this.edit = false
          })
          .catch(() => this.$store.dispatch('app/hideLoading'))
      } else {
        addInvoice(params)
          .then((res) => {
            Notify({ type: 'success', message: '保存成功' })
            this.$store.dispatch('app/hideLoading')
            this.clearFile()
            this.getData()
            this.edit = false
          })
          .catch(() => this.$store.dispatch('app/hideLoading'))
      }
    },
    uploadAvatar(file) {
      return new Promise((resolve, reject) => {
        const params = new FormData()
        params.append('file', file)
        uploadImage(params)
          .then((res) => {
            resolve(res.data)
          })
          .catch(reject)
      })
    },
    clearFile() {
      for (const key in this.file) {
        if (Object.hasOwnProperty.call(this.file, key)) {
          this.file[key] = null
        }
      }
    },
    afterReadBusinessLicenceImg(file) {
      this.afterRead(file.file, 'businessLicenceImg')
    },
    afterReadTaxpayerIdentificationImg(file) {
      this.afterRead(file.file, 'taxpayerIdentificationImg')
    },
    afterRead(file, key) {
      const size = file.size
      const maxSize = 5 * 1000 * 1000
      if (size < maxSize) {
        this.file[key] = file
      } else {
        new Compressor(file, {
          quality: 0.6,
          success: (result) => {
            this.file[key] = result
          },
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.content {
  .tips {
    font-size: 28px;
    line-height: 40px;
    padding: 12px 24px;
    color: #2f2f2f;
    background-color: #cecece;
    text-align: center;
    &.red {
      color: #ff0000;
      background-color: #ffc6c6;
    }
  }
  .label {
    font-size: 28px;
    line-height: 1em;
    padding: 28px 24px 0;
  }
  .tip {
    font-size: 22px;
    color: #cecece;
    line-height: 32px;
  }
  .van-form {
    .van-cell {
      font-size: 28px;
      line-height: 1em;
      padding: 28px 24px;
      /deep/ .van-field__label {
        color: #333333;
      }
      /deep/ .van-field__value .van-field__control--custom {
        align-items: flex-end;
        .van-uploader__upload,
        .van-uploader__preview {
          margin-bottom: 0;
          margin-right: 24px;
        }
      }
      &::after {
        border-color: #f2f2f2;
      }
    }
    .field-uploader {
      padding-top: 16px;
    }
  }
  .bottom {
    padding: 50px 40px 0;
    .btn {
      margin-bottom: 80px;
      line-height: 68px;
      font-size: 28px;
      text-align: center;
      color: #fff;
      background: linear-gradient(135deg, #e82237 0%, #ff9d9d 100%);
      border-radius: 38px;
      border: 2px solid #fe6979;
      &.disable {
        background: #d6d6d6;
        border: #d6d6d6;
      }
    }
  }
}
</style>